/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import HandbookPage from './Show/HandbookPage';
import { ProtectedRouter } from 'infrastructure/routing';
import { Router, Route } from 'framework/routing';
import { HANDBOOK_PATH } from 'domain/shared/core/sharedRouteConstants';
import { useHandbookRoute } from 'domain/gpo/handbook/handbookRoute';

const HandbookRouter: Router = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute } = useHandbookRoute();

  return (
    <ProtectedRouter basePath={HANDBOOK_PATH}>
      <Routes>
        <Route path={`${listRoute}/*`} element={<HandbookPage />} />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

HandbookRouter.getRouterPath = () => `${HANDBOOK_PATH}/*`;

export default HandbookRouter;
